module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ui-select', {
    attrs: {
      "name": _vm.name,
      "label": _vm.label,
      "keys": _vm.keys,
      "value": _vm.model,
      "options": _vm.options,
      "placeholder": _vm.placeholder,
      "multiple": true,
      "required": _vm.required
    },
    on: {
      "input": _vm.onInput
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-365bb7b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui/ISelectMultiple.vue
// module id = 244
// module chunks = 0